/*
 * RIDECLOUD TICKER BANNER
 * Style: Original RideCloud — dark purple strip below hero
 * Shows included benefits scrolling across
 * Colours: #2e004f bg, white text, #e6531e accent
 */

const items = [
  "Comprehensive Insurance",
  "Routine Maintenance",
  "24/7 Roadside Assistance",
  "Vehicle Tracking",
  "Licensing Included",
  "No Balloon Payments",
  "No Long-Term Debt",
  "Flexible Terms",
  "Upgrade Anytime",
  "One Monthly Fee",
];

export default function TickerBanner() {
  const doubled = [...items, ...items];

  return (
    <div
      className="w-full overflow-hidden py-3"
      style={{
        backgroundColor: "#2e004f",
        borderTop: "1px solid rgba(230,83,30,0.25)",
        borderBottom: "1px solid rgba(230,83,30,0.25)",
      }}
    >
      <div className="ticker-track">
        {doubled.map((item, i) => (
          <span
            key={i}
            className="flex items-center gap-2 px-6 text-sm font-medium whitespace-nowrap flex-shrink-0"
            style={{ color: "rgba(255,255,255,0.80)" }}
          >
            <span style={{ color: "#e6531e", fontWeight: "bold" }}>✓</span>
            {item}
            <span style={{ color: "rgba(230,83,30,0.4)", marginLeft: "0.75rem" }}>|</span>
          </span>
        ))}
      </div>
    </div>
  );
}
